import "../../../node_modules/@codat/orchard-ui/dist/index.css";
import "../../index.css";

import { AnalyticsProvider } from "@codat/analytics";
import { OrchardProvider } from "@codat/orchard-ui";
import * as React from "react";
import { Observable } from "rxjs";

import config from "config";

import { ProxyApiProvider } from "../../contexts/ProxyApiContext";
import { PublicApiProvider } from "../../contexts/PublicServiceContext";
import styles from "./App.module.scss";
import AppRouter from "./AppRouter";

interface AppProps {
  queueSync$?: Observable<void>;
}

const App: React.FC<AppProps> = ({ queueSync$ }) => (
  <div className={styles.app}>
    <PublicApiProvider>
      <ProxyApiProvider>
        <OrchardProvider appId="data-history-ui">
          <AppRouter queueSync$={queueSync$} />
        </OrchardProvider>
      </ProxyApiProvider>
    </PublicApiProvider>
  </div>
);

const AnalyticsWrapper: React.FC<AppProps> = (props) => (
  <AnalyticsProvider
    config={{
      appName: "Data History",
      apiKey: config.AMPLITUDE_API_KEY,
      mode: config.ENVIRONMENT === "Integration" ? "development" : "production",
    }}
  >
    <App {...props} />
  </AnalyticsProvider>
);

export default AnalyticsWrapper;
